<style lang="scss" scoped>
iframe {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
}
.document-loading {
    left: 50%;
    transform: translateX(-50%);
    top: 50%;
    transform: translateY(-50%);
}
</style>

<template>
    <div>
        <div v-if="loading" class="document-loading primary position-absolute d-flex flex-column">
            <span class="mb-15">{{ $t('general.loading') }}</span>
            <el-loader :loading="loading" class="primary mx-auto" />
        </div>
        <iframe v-show="!loading" ref="iframe" :src="frameUrl" @load="load">

        </iframe>
    </div>
</template>

<script>
import iframeReload from '@/mixins/iframe-reload'

export default {
    name: 'iframe-show',

    components: {
        ElLoader: () => import(/* webpackChunkName: "elements" */ '@/components/forms/ElLoader'),
    },

    mixins: [iframeReload],

    props: {
        frameUrl: {
            type: String,
            required: true,
        }
    },

    data: () => ({
        loading: true,
    }),

    mounted() {
        this.reloadIfNoContent(this.$refs.iframe, this.frameUrl)
    },

    methods: {
        load() {
            this.stopReloading()
            this.loading = false
        },
    }
};
</script>
